export class UserDetailModel {
    email: string
    first_name: string
    id: number
    image: string
    is_sales_person: false
    job_title: string
    last_name: string
    middlename: string
    permission: [PermissionsModel]
    application_permission: ApplicationPermission[];
    group_permission: {
                            name: string;
                            permissions: string;
                    }[]
    roles: string
    type: any
    username: string
    teams: []
}

interface ApplicationPermission {
    id: number;
    name: string;
  }

export class LoginModel {
    message: string
    status: boolean
    token: string
    user: UserDetailModel
}

export class PermissionsModel{
    action: string
    content_type: string
    id: number
    name: string
    selected: boolean = false
}

export interface Notification {
    created_at:string
    file:any
    id:number
    is_read:boolean
    message:string
    object:number
    object_name:string
    service:string
    task:number
    task_name:string
    type:number
    user:number
    value:string
    task_due_date:string
    type_name:string
    domain:string 
    domain_name:string
    
}

export interface NotificationResponseModal {
    count:number
    next:string
    previous:string
    results:Notification[]
}